var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wind" },
    [
      _vm.$route.query.isBanner == 0 && _vm.$route.query.isApp == 1
        ? _c("van-icon", {
            attrs: {
              id: "backIcon",
              name: _vm.isDirection ? "arrow" : "arrow-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.back()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b", [_vm._v(_vm._s(_vm.$t("300148")))]),
          _vm._v(" "),
          _vm.winPeople.length > 0
            ? _c("div", { staticClass: "main" }, [
                _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("300418")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("300085")))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "winuser" }, [
                  _c(
                    "div",
                    _vm._l(_vm.winPeople, function(item, index) {
                      return _c("p", { key: index }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              index + 1 >= 10 ? index + 1 : "0" + (index + 1)
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.account))])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _c(
                "van-empty",
                {
                  staticClass: "custom-image",
                  attrs: { description: _vm.$t("300108") }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-jilu1" } })]
                  )
                ]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8b48252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b48252","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/winprize.vue
// module id = ZTS/
// module chunks = 0